/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConceptNode } from './conceptNode';
import type { ConceptEdge } from './conceptEdge';
import type { ConceptCluster } from './conceptCluster';

/**
 * The 'Universe of Concepts'.
 */
export interface ConceptGraphInput {
  nodes: ConceptNode[];
  edges: ConceptEdge[];
  clusters: ConceptCluster[];
}
